import React, { FC, ReactNode } from 'react'
import './icon.scss'

export const RentLegislationHighlighterIcon: FC<ReactNode> = () => {
  return (
    <div className='icon-container'>
      <img
        srcSet={
          'https://www.static-immobilienscout24.de/statpic/sales-journey/hos/rle-wizard/icons/59ed7a21c0c0d35d13c06d700878d700_IS24_RentLegislation_highlighter.png, ' +
          'https://www.static-immobilienscout24.de/statpic/sales-journey/hos/rle-wizard/icons/a2a96e86ef2a5c88832c150559d57dac_IS24_RentLegislation_highlighter@2x.png 2x, ' +
          'https://www.static-immobilienscout24.de/statpic/sales-journey/hos/rle-wizard/icons/a3e4d2fd311e874f90da2605596ee5e4_IS24_RentLegislation_highlighter@3x.png 3x'
        }
        src={
          'https://www.static-immobilienscout24.de/statpic/sales-journey/hos/rle-wizard/icons/59ed7a21c0c0d35d13c06d700878d700_IS24_RentLegislation_highlighter.png'
        }
        width={82}
        height={85}
        alt={''}
      />
    </div>
  )
}
